<template>
  <el-select
    v-model="optionValue"
    filterable
    placeholder="请选择店铺"
    :style="styleRef"
    @change="handleChange"
    clearable
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { getMyList } from "@/api/store";

export default {
  props: {
    styleRef: {
      type: Object
    },
    type: {
      type: String
    },
    refValue: {
      type: Number
    }
  },
  created() {
    this.getMyList();
  },
  watch: {
    refValue: function(val) {
      this.optionValue = val;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      optionValue: this.value,
      options: []
    };
  },
  mounted() {
  },
  methods: {
    /**
     * 查询级联标签
     */
    getMyList() {
      const params = {};
      getMyList(params).then(resp => {
        this.options = resp.data || [];
      });
    },
    /**
     * 节点选中的值
     * @param events
     */
    handleChange(events) {
      this.$emit("valueFunc", this.type, events);
    }
  }
};
</script>

<style scoped lang="scss"></style>
